// SUB-OFFICE 7 — entry point. esbuild bundles this to public/game.js (IIFE).
// The shell (public/index.html) shows the carbon dark and the stuttering tube;
// bootBureau() assembles the hall behind it and then lets the light catch.

import { bootBureau } from './boot';

function start(): void {
  try {
    bootBureau();
  } catch (err) {
    // If the hall cannot assemble, the paper notice stands in. In voice, always.
    console.warn('[bureau] boot did not complete', err);
    const bootCover = document.getElementById('boot');
    if (bootCover) bootCover.remove();
    const noWindow = document.getElementById('nowindow');
    if (noWindow) noWindow.classList.add('shown');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
